module.exports = __webpack_public_path__ + "static/Ahkio-Regular.e716571f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Ahkio-Regular.woff
// module id = 465
// module chunks = 114276838955818